import { render, staticRenderFns } from "./personal-quote-info.vue?vue&type=template&id=1a588ede&scoped=true&"
import script from "./personal-quote-info.vue?vue&type=script&lang=js&"
export * from "./personal-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-quote-info.vue?vue&type=style&index=0&id=1a588ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a588ede",
  null
  
)

export default component.exports